import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["eventsList", "datePicker"]
  static values = {
    minDate: String,
    currentDate: String,
    baseUrl: String,
    availableDates: Array
  }

  connect() {
    if (this.hasEventsListTarget) {
      this.originalEventsMarkup = this.eventsListTarget.innerHTML
    }

    this.handleVisitBound = this.handleBeforeVisit.bind(this)
    this.handleBeforeCacheBound = this.handleBeforeCache.bind(this)
    this.handlePageShowBound = this.handlePageShow.bind(this)
    document.addEventListener("turbo:before-visit", this.handleVisitBound)
    document.addEventListener("turbo:before-cache", this.handleBeforeCacheBound)
    window.addEventListener("pageshow", this.handlePageShowBound)

    if (this.hasDatePickerTarget) {
      this.initFlatpickr()
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.handleVisitBound)
    document.removeEventListener("turbo:before-cache", this.handleBeforeCacheBound)
    window.removeEventListener("pageshow", this.handlePageShowBound)

    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy()
    }
  }

  handleBeforeVisit(event) {
    if (!this.hasEventsListTarget) return

    this.eventsListTarget.innerHTML = `
      <div class="flex justify-center py-3">
        <div class="inline-flex h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-primary" role="status" aria-label="Loading"></div>
      </div>
    `
  }

  handleBeforeCache() {
    this.resetEventsList()
  }

  handlePageShow() {
    this.resetEventsList()
  }

  initFlatpickr() {
    const minDate = this.minDateValue || new Date()
    const currentDate = this.currentDateValue || new Date()
    const availableDates = this.availableDatesValue || []
    const availableDateSet = new Set(availableDates)

    this.flatpickrInstance = flatpickr(this.datePickerTarget, {
      dateFormat: "Y-m-d",
      minDate: minDate,
      defaultDate: currentDate,
      enable: availableDates,
      disableMobile: "true",
      position: 'auto center',
      locale: {
        firstDayOfWeek: 1
      },
      onDayCreate: (_selectedDates, _dateStr, _instance, dayElement) => {
        const date = this.formatDate(dayElement.dateObj)
        if (!availableDateSet.has(date)) return

        dayElement.classList.add("mojo-available-date")
      },
      onChange: (selectedDates) => {
        if (selectedDates.length > 0) {
          this.visitSelectedDate(selectedDates[0])
        }
      }
    })
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  visitSelectedDate(date) {
    const formattedDate = this.formatDate(date)
    const baseUrl = this.baseUrlValue || window.location.pathname
    const url = new URL(baseUrl, window.location.origin)
    url.searchParams.set('date', formattedDate)

    Turbo.visit(`${url.pathname}${url.search}${url.hash}`, { action: "advance" })
  }

  resetEventsList() {
    if (!this.hasEventsListTarget || !this.originalEventsMarkup) return

    this.eventsListTarget.innerHTML = this.originalEventsMarkup
  }
}
